/**
 * @file text-input.component.tsx
 * @description Компонент обертка для работы с @consta/uikit/TextField.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-18
 * @dependencies ['@consta/uikit/TextField', 'react']
 * @related-files []
 */

import { TextField } from '@consta/uikit/TextField';
import { ComponentProps, forwardRef, Ref } from 'react';

type TTextInputProps = ComponentProps<typeof TextField>;

export const TextInput = forwardRef<HTMLInputElement, TTextInputProps>(
    ({ size = 's', ...props }, ref: Ref<HTMLInputElement>) => {
        return <TextField ref={ref} size={size} {...props} />;
    }
);
